import React, { useState, useEffect, useRef } from 'react';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import Fade from 'react-bootstrap/Fade';
// import Button from 'react-bootstrap/Button';


const ColorShades = ({ color, interval , removeColor}) => {
  const [shades, setShades] = useState([]);
  const [copied, setCopied] = useState(false);
  const [open, setOpen] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);
  const containerRef = useRef(null); // Add a ref to the container



  useEffect(() => {
    const shades = calculateShades(color, interval);
    setShades(shades);
  }, [color, interval]);

  useEffect(() => {
    if((!open) & firstLoad){
      const timer = setTimeout(() => {
        setFirstLoad(false);
        setOpen(true);
      }, 200);
      return () => clearTimeout(timer);     
      
    } else if(!open){
      const timer = setTimeout(() => {
        setOpen(true)
        removeColor();
      }, 350);
      return () => clearTimeout(timer);}
  });

  useEffect(() => {
    if (containerRef.current) {
      // Scroll to the middle of the container
      const container = containerRef.current;
      container.scrollLeft = (container.scrollWidth - container.clientWidth) / 2;
    }
  }, [shades]);

  const handleRemove = () =>{
    setOpen(false);
  }

  const calculateShades = (hex, interval) => {
    const shades = [];
    const rgb = hexToRgb(hex);
    let new_color = "";
    for (let i = 1; i <= 5; i++) {
      new_color = mixColors(rgb, [255, 255, 255], (i * interval) / 100);
      if (!shades.includes(new_color)) {
        shades.push(new_color);
      }
    }

    new_color = mixColors(rgb, rgb, 0);
    if (!shades.includes(new_color)) {
      shades.push(new_color);
    }

    for (let i = 5; i >= 1; i--) {
      new_color = mixColors(rgb, [0, 0, 0], (i * interval) / 100);
      if (!shades.includes(new_color)) {
        shades.push(new_color);
      }
    }

    return shades;
  };

  const hexToRgb = (hex) => {
    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b);

    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? [
          parseInt(result[1], 16),
          parseInt(result[2], 16),
          parseInt(result[3], 16),
        ]
      : null;
  };

  const mixColors = (color1, color2, ratio) => {
    ratio = Math.min(1, Math.max(0, ratio));
    const mixedColor = color1.map((channel, index) =>
      Math.round(channel * ratio + color2[index] * (1 - ratio))
    );
    return `rgb(${mixedColor.join(',')})`;
  };

  const rgbToHex = (rgb) => {
    const [r, g, b] = rgb.match(/\d+/g);
    return (
      '#' +
      ((1 << 24) + (parseInt(r) << 16) + (parseInt(g) << 8) + parseInt(b))
        .toString(16)
        .slice(1)
    );
  };

  const handleCopy = (shade) => {
    try {
      navigator.clipboard.writeText(rgbToHex(shade));
      setCopied(true);
      setTimeout(() => setCopied(false), 1000); // Reset copied state after 1 second
    } catch (error) {
      console.error('Failed to copy to clipboard:', error);
      // Handle the error as needed, such as displaying an error message to the user
    }
  };

  const getContrastColor = (hexColor) => {
    const r = parseInt(hexColor.substr(1, 2), 16);
    const g = parseInt(hexColor.substr(3, 2), 16);
    const b = parseInt(hexColor.substr(5, 2), 16);
    
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    
    let hex_value = luminance > 0.5 ? '#000000' : '#FFFFFF';

    if (hex_value.startsWith('#')) {
      hex_value = hex_value.slice(1);
    }

    let r2 = parseInt(hex_value.substring(0, 2), 16);
    let g2 = parseInt(hex_value.substring(2, 4), 16);
    let b2 = parseInt(hex_value.substring(4, 6), 16);
    let alpha = 0.7;

    return `rgba(${r2}, ${g2}, ${b2}, ${alpha})`;
  };
 
  return (
    <Fade in={open}>
    <div 
      ref={containerRef}
      style={{ 
      display: "flex", 
      justifyContent: "center", 
      flexDirection: "column", 
      overflowX: "auto",
      maxWidth:"100%",
      flexWrap:"wrap",
      
      }}>
      <div style={{ minWidth: "100%" }}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', }}>
          {shades.map((shade, index) => (
            <div key={index}>
              {index === Math.floor(shades.length / 2) ? (
                <div
                  style={{
                    position: 'relative',
                    minWidth:"80px",
                    minHeight:"80px",
                    width: '8vw',
                    height: '12vh',
                    backgroundColor: shade,
                    marginTop: '1vh',
                    marginBottom: '1vh',
                    transition: "padding 0.4s",
                    border: `2px solid ${getContrastColor(rgbToHex(shade))}`,
                  }}
                  >
                  <Tooltip title={copied? "Copied":"Click to copy"} placement="top" TransitionComponent={Zoom}>
                    <div style={{
                      display: 'flex',
                      justifyContent: 'center',
                      position: 'relative',
                      width: '100%', // Make the width 100% of the parent
                      height: '10vh'
                      
                    }}>
                      <Button
                        style={{
                          color: getContrastColor(rgbToHex(shade)),
                        }}
                        variant="text"
                        onClick={() => handleCopy(shade)}
                        >
                        {rgbToHex(shade)}
                      </Button>
                    </div>
                  </Tooltip>
                  <Tooltip title={open? "Delete": "OUCH !"} TransitionComponent={Zoom}>
                    <IconButton 
                      style={{
                        position: 'absolute',
                        bottom: 0,
                        left: '50%', // Align to the horizontal center
                        transform: 'translateX(-50%)', // Adjust to center the icon
                        color:getContrastColor(rgbToHex(shade)),
                        borderRadius:"25px",
                      }}
                      aria-label="delete"
                      onClick={handleRemove}
                      >
                      <DeleteIcon style={{width:"90%"}} />
                    </IconButton>
                  </Tooltip>
                </div>
              ) : (
                <Tooltip title={copied? "Copied !":"Click to copy"} placement="top" TransitionComponent={Zoom}>
                  <div>
                    <Button
                      style={{
                        backgroundColor: shade,
                        color: getContrastColor(rgbToHex(shade)),
                        minWidth:"70px",
                        minHeight:"70px",
                        width: '7vw',
                        height: '10vh',
                        marginTop: '0.3vh',
                        marginBottom: '0.3vh',
                        borderRadius: "0",
                        transition: "padding 0.4s",
                        border: "none",
                        display: "flex",
                        flexDirection: "column"
                      }}
                      variant="text"
                      onClick={() => handleCopy(shade)}
                      onMouseOver={(e) => { e.target.style.paddingTop = "5vh"; e.target.style.paddingBottom = "7vh"; e.target.style.boxShadow = "inset 0 0 1vw rgba(0,0,0,0.5)"; }}
                      onMouseOut={(e) => { e.target.style.paddingTop = "0"; e.target.style.paddingBottom = "0"; e.target.style.boxShadow = "none"; }}
                      >
                      {rgbToHex(shade)}
                      
                    </Button>
                  </div>
                </Tooltip>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
    </Fade>
  );    
}

export default ColorShades;
